import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {OptimizationCardScratchpadState} from '../../scratchpad/optimizationCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import attributionSignalsApi from 'common/src/modules/attributionSignals/attributionSignals.api';
import supportsAttributionSignals from '../../utils/optimization/supportsAttributionSignals';

export default function getAttributionSignalsTool() {
  async function execute(
    params: ToolExecuteParams<z.ZodObject<Record<string, never>>, OptimizationCardScratchpadState>,
  ) {
    const validatedScratchpad = validateAgentScratchpad<OptimizationCardScratchpadState>(
      params.toolUtils.agentScratchpad,
      NodeType.GENERAL_OPTIMIZATION,
    );

    if (!validatedScratchpad.card.configuration) {
      return toolError('Optimization configuration not found');
    }

    const {configuration} = validatedScratchpad.card;

    // Check if current optimizeBy supports attribution signals
    if (!supportsAttributionSignals(configuration.optimizeBy)) {
      return toolError(
        'Attribution signals are only available when optimizing by Conversions or Click Through Conversions',
      );
    }

    const attributionSignals = await attributionSignalsApi.getAttributionSignals();

    return toolResult(JSON.stringify(attributionSignals));
  }

  return tool<z.ZodObject<Record<string, never>>, OptimizationCardScratchpadState>({
    name: V2CardAgentToolName.GetAttributionSignals,
    displayName: 'Getting attribution signals',
    description:
      'Get available attribution signals for the current optimization metric. Only available for Conversions or ClickThroughConversions. For ClickThroughConversions, only Click-type signals are returned.',
    inputSchema: z.object({}),
    execute,
  });
}
